import React from 'react'
import './BookDetail.scss'
import { useHistory } from 'react-router-dom'
import {
  Button,
  Col,
  Container,
  Row
} from 'reactstrap'
import Book from '../Book/Book'

function BookDetail(book) {
  const { copy, title } = book
  const createMarkup = () => ({ __html: copy })
  const history = useHistory()
  return (
    <Container fluid className="BookDetail d-flex flex-column pb-5">
      <Button className="text-muted" color="link" onClick={() => history.goBack()}>Go Back</Button>
      <article className="mt-5 d-flex flex-column">
        <h1 className="text-center">{ title }</h1>
        <Row className="justify-content-center">
          <Col xs={10} md={4}>
            <Book {...book } />
          </Col>
          <Col xs={11} md={8} className="my-auto">
            <p className="m-4" dangerouslySetInnerHTML={ createMarkup() } />
          </Col>
        </Row>
      </article>
    </Container>
  )
}

export default BookDetail
